import { jsx as _jsx } from "react/jsx-runtime";
import { Callout } from './callout';
import { CodeBlock } from './code-block/code-block';
import { Image } from './image';
import { Heading } from './heading';
import { Frame } from './frame';
import Link from 'next/link';
import { codeToHtml } from './code-block/highlighter';
const h1 = (props) => _jsx(Heading, { level: 1, ...props });
const h2 = (props) => _jsx(Heading, { level: 2, ...props });
const h3 = (props) => _jsx(Heading, { level: 3, ...props });
const h4 = (props) => _jsx(Heading, { level: 4, ...props });
const h5 = (props) => _jsx(Heading, { level: 5, ...props });
const h6 = (props) => _jsx(Heading, { level: 6, ...props });
export { Callout, CodeBlock, Image, Frame, Link, Heading, codeToHtml };
export const mdxComponents = {
    Callout,
    CodeBlock,
    Image,
    Frame,
    Link,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
};
